import { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Icon } from '../Icons/Icon';
import { Button } from './Button';
import { Logo } from './Logo';
import './Footer.css';
import Loader from './Loader';
import { DataService } from '../DataService/DataService';
import { EmailListEntryDto } from '../Types/EmailListEntryDto';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubscribing, setIsSubscribing] = useState(false);

  const handleNewsletterSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      toast.error('Vänligen ange din e-postadress',{position:'bottom-right'});
      return;
    }

    setIsSubscribing(true);
              const formData = {
                      name: '',
                      email: email,
                      newsListSignUp:true
                    } as EmailListEntryDto
              const submitRes =   await DataService.EmailList.SendEmailEntryForm(formData);
              setIsSubscribing(false);
              submitRes ?   
              toast.success("Tack", {
                position: "top-right"
                }):toast.error("Något gick fel försök igen.",{
                  position: "top-right"
                });
    
  };
  return (
  <footer className="footer">
    <div className="footer-container">
      <div className="footer-grid">
        {/* Logo and Description */}
        <div className="footer-logo-section">
          <Logo className="footer-logo" />
          <p className="footer-description">
            Din partner för en hälsosammare livsstil. Vi erbjuder expertkurser
            inom nutrition, mental hälsa och välmående.
          </p>
          {/* Newsletter Signup */}
            <div className="mb-6">
              <h4 className="text-lg-font-semibold-mb-3-text-f39e60">Prenumerera på vårt nyhetsbrev</h4>
              <form onSubmit={handleNewsletterSignup} className="flex-flex-col-sm-flex-row-gap-2-max-w-md">
                <input
                  type="email"
                  placeholder="Din e-postadress"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="bg-white-10-border-white-20-text-white-placeholder-text-white-60-focus-border-f39e60"
                />
                <Button 
                  style={{width:'30%'}}
                  disabled={isSubscribing}
                  className="submit-button"
                  text={isSubscribing ? <div style={{position:'relative',display:'flex',justifyContent:'center'}}><Loader loaderSize={'SMALL'}/></div> : 'Prenumerera'}
                  //className="bg-[#F39E60] hover:bg-[#E16A54] text-white border-0 whitespace-nowrap"
                />
              </form>
              <p className="text-white-60-text-sm-mt-2">
                Få hälsotips, kursuppdateringar och exklusiva erbjudanden.
              </p>
            </div>
          <div className="footer-socials">
            <a rel="noreferrer" target="_blank" href="https://www.facebook.com/profile.php?id=61576233733917" className="social-icon" aria-label="Facebook">
              <Icon.FacebookIcon/>
            </a>
            <a rel="noreferrer" target='_blank' href="https://www.instagram.com/sandrashalsa_?igsh=bHVmMXp4eHduMDJt" className="social-icon" aria-label="Instagram">
              <Icon.InstagramIcon/>
            </a>
            <a href="https://www.linkedin.com/" rel="noreferrer" target="_blank" className="social-icon" aria-label="LinkedIn">
              <Icon.LinkedInIcon />
            </a>
          </div>

          <div className="footer-payments" aria-label="Betalningsmetoder">
            <p className="footer-payments-label">Betalningsmetoder</p>
            <div className="footer-payments-row">
              <div className="footer-payment-icon footer-payment-icon--swish" aria-label="Betalning med Swish">
                <Icon.SwishIcon width={58} height={58} wordmarkFill="#F9F8F5" />
              </div>
              <div className="footer-payment-icon footer-payment-icon--stripe" aria-label="Betalning med Stripe">
                <Icon.StripeIcon width={58} height={58} />
              </div>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        
      <div>
          <h4 className="footer-heading">Snabblänkar</h4>
          <ul className="footer-links">
            {/* <li><a href="#kurser">Alla kurser</a></li>
            <li><a href="#om-oss">Om oss</a></li>
            <li><a href="#om-oss">Samtal</a></li> */}
            <li><a href="/contact">Kontakta</a></li>
          </ul>
        </div>
        {/* Legal */}
        <div>
          <h4 className="footer-heading">Juridiskt</h4>
          {/* <ul className="footer-links">
            <li><a href="#a">Allmänna villkor</a></li>
            <li><a href="#i">Integritetspolicy</a></li>
            <li><a href="#c">Cookies</a></li>
            <li><a href="#g">GDPR</a></li>
          </ul> */}
          <ul className='footer-links'>
            <li><a href="/terms-of-service">Köpvillkor & Ångerrätt</a></li>
            <li><a href="/privacy-policy">GDPR</a></li>
          </ul>
        </div>
        
      </div>
      <div className="footer-bottom">
        <p>© 2025 Sandras hälsa. Alla rättigheter förbehållna.</p>
      </div>
    </div>
    <ToastContainer/>
  </footer>
);

}
export default Footer;
